import React from 'react'
import AboutUs from '../components/AboutUs'
import AboutUs2 from '../components/AboutUs2'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

const About = () => {
    return (
        <>
        <Navbar />      
      <AboutUs/>
      <AboutUs2/>
      
      
      <Footer/>
      </>
    )
}

export default About
